/** Browser-side CSV download helpers for admin reports. */

function escapeCell(value) {
    if (value == null) return '';
    const s = String(value);
    if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
}

/** @param {string[]} headers @param {Array<Array<string|number|null|undefined>>} rows */
export function toCsv(headers, rows) {
    const lines = [
        headers.map(escapeCell).join(','),
        ...rows.map((row) => row.map(escapeCell).join(',')),
    ];
    return lines.join('\r\n');
}

/** Trigger a CSV file download in the browser. */
export function downloadCsv(filename, headers, rows) {
    const csv = toCsv(headers, rows);
    // BOM so Excel opens UTF-8 correctly.
    const blob = new Blob(['\uFEFF', csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}

/** Flatten month → vendor report JSON into CSV rows (month total + each vendor). */
export function flattenMonthVendorRows(months, mapTotals, mapVendor) {
    const rows = [];
    for (const m of months || []) {
        rows.push(mapTotals(m.month, m.totals || {}));
        for (const v of m.vendors || []) {
            rows.push(mapVendor(m.month, v));
        }
    }
    return rows;
}
